__turbopack_context__.v({
  "className": "amiri_52ddb859-module__els15a__className",
});
